<template>
  <div class="section-post-creator" :class="[mode, { 'conciergerie-edit': mode === 'update' && isFacebookConciergerieEdit }]">

    <header>
      <div class="container-title">

        <div class="btn-back" v-if="!isDemo" @click="goBackToPlanner();"></div>
        <div class="text">
          <h2 class="title">{{title}}</h2>
          <p v-if="!previewMode.active && ['create','duplicate'].includes(mode) && canRestoreDraft" class="switchOldVersion" @click="$emit('retoreDraftInLocalStorage')">{{ $t('dash.post-creator.action.restore-draft') }}</p>
          <p v-else-if="mode !== 'create'" class="switchOldVersion" @click="goBackToPlanner();">{{ $t('dash.post-creator.back-to-planner') }}</p>
        </div>

      </div>
      <!-- button personalisation -->
      <div class="custom-edtion-mode" v-if="!previewMode.active && customModeIsAvailable">

        <h5 @click="handleChangecustomMode(!customMode.active)">{{ $t('dash.post-creator.custom-mode.title') }}</h5>

        <ComponentSwitch :value="customMode.active" :onChange="(value)=>handleChangecustomMode(value)" :id="'switchEditionMode'"></ComponentSwitch>

        <div class="tutorial" v-if="!customMode.active && showTutorial">
          <svg width="29" height="31" viewBox="0 0 29 31" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.61478 29.4303C3.46662 10.3949 6.9428 1.2045 27.9404 0.99937M7.61478 29.4303L1.21998 23.77M7.61478 29.4303L12.2981 22.1357" stroke="#B64985" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          {{ $t('dash.post-creator.custom-mode.hint') }}
        </div>
      </div>

      <div class="btns-action">
        <template v-if="previewMode.active">
          <div class="btn-outline-primary" @click="()=>handlerChangePreviewDisplay(false)">{{ $t('dash.button.go_back') }}</div>

          <div v-if="textBtnFinish && !isFileUploading && !hasFailedUpload" class="btn-secondary icon-r " @click="sendPostAllPost">{{textBtnFinish}}<i class="fa-solid fa-arrow-right"></i></div>
          <Tooltip v-else :text="uploadBlockedTooltipText" :active="isFileUploading || hasFailedUpload" :classCustom="'btn-secondary icon-r disable'" position="bottom">
            {{textSwitchPreview}}
            <i class="fa-solid fa-arrow-right"></i>
          </Tooltip>
        </template>

        <template v-else>
          <template  v-if="mode !== 'update' && formData.planifiedDate.date" >
            <div v-if="isCurrentUserAssigned" class="btn assign" @click="unassignCurrentUser">
              {{ $t('dash.post-creator.user.unassign') }}
              <i class="fa-solid fa-user-minus"></i>
            </div>
            <div v-else class="btn assign" @click="assignUsers">
              {{ $t('dash.post-creator.user.assign') }} {{ idUsersAssigned.length ? `(${idUsersAssigned.length})` : '' }}
              <i class="fa-solid fa-user-plus"></i>
            </div>
          </template>

          <div class="template-trigger-wrapper" v-if="mode === 'create' && templatesFeatureEnabled">
            <TemplateTrigger :open="showPostTemplatePicker" @open="action => { postTemplateAction = action; showPostTemplatePicker = true }">
              <div class="assign btn-template" :class="{ active: showPostTemplatePicker }">
                <i class="fa-regular fa-swatchbook"></i>
                {{ $t('dash.templates.apply-text') }}
              </div>
            </TemplateTrigger>
            <TemplatePicker
              v-if="showPostTemplatePicker"
              :action="postTemplateAction"
              type="post"
              :save-data="savePostTemplateData"
              show-post-preview
              @apply="onApplyPostTemplate"
              @saved="showPostTemplatePicker = false"
              @close="showPostTemplatePicker = false"
            />
          </div>

          <Tooltip
            :text="$t('dash.post-creator.media.uploading')"
            :active="false && isFileUploading"
            position="bottom"
          >
            <div
              v-if="mode !== 'update' && !(formData.planifiedDate.date && idUsersAssigned.length && requiredValidation)"
              class="btn-outline-primary"
              :class="{'disable': isSavingDraft || !pagesSelected.length}"
              @click="!isSavingDraft && pagesSelected.length && saveDraft()">
              {{ isMongoDraftEdit ? $t('dash.post-creator.action.save') : { create : $t('dash.post-creator.action.save-draft'), duplicate : $t('dash.post-creator.action.save-draft'), edit: $t('dash.post-creator.action.convert-to-draft'), draft : $t('dash.post-creator.action.save')}[mode || 'create'] }}
            </div>
          </Tooltip>

          <Tooltip
            :text="uploadBlockedTooltipText"
            :active="isFileUploading || hasFailedUpload"
            position="bottom"
          >
            <div
              class="btn-secondary icon-r"
              :class="{'disable': isFileUploading || hasFailedUpload}"
              @click="()=>handlerChangePreviewDisplay(true)">
              {{textSwitchPreview}}
              <i class="fa-solid fa-arrow-right"></i>
            </div>
          </Tooltip>


        </template>




      </div>
    </header>
    <div :class="'post-creator '+formShow" ref="postCreator" >
      <div class="container-form" v-if="formShow == 'formMultiple'">
        <div class="nav-type-post">
          <div class="icon-l btn-primary"><i class="fa-solid fa-pen-to-square"></i>Standard</div>
          <div v-if="pagesSelectedIncludeConciergerie && pagesInstagramActivedShareStory.length" @click.stop="()=>switchTab('story_share')" class="icon-l"><i class="fa-solid fa-share-from-square"></i>Partage en story</div>
          <div v-else-if="!pagesSelected.some(page => page.network !== 'instagram' && !(page.network === 'facebook' && page.story_config && page.story_config.created)) && !hasMixedStoryNetworks" class="icon-l" @click.stop="()=>switchTab('story')"><i class="fa-solid fa-camera-retro"></i>Story</div>
        </div>
        <div class="container-form-scroll hide-scrollbar">
          <div class="form">
            <div class="list-pages-selected">
              <div v-if="mode !== 'update'" class="btn-add-page" :class="{retract: pagesSelected.length}" @click="openSelectPage">
                <i class="fa-solid fa-plus"></i>
                <p>{{ $t('dash.post-creator.pages.add') }}</p>
              </div>
              <div class="container-list-avatars hide-scrollbar">
                <div class="list-avatars hide-scrollbar">
                  <Tooltip
                    v-for="page in pagesSelected"
                    :text="page.name"
                    :key="page.id"
                  >
                  <ContextMenu
                    :options="pageContextMenuOptions(page)"
                    :id="'contextMenuPage'+page.id"
                    v-on:clickOption="(_, name)=> clickContextMenuPage(name, page)"
                  >
                    <Avatar :urlPicture="page.avatar" :typeNetwork="page.network"></Avatar>
                  </ContextMenu>
                  
                  </Tooltip>
                </div>
              </div>
            </div>
            <Form
              ref="form"
              @setSelectTypeRenderNetwork="selectTypeNetwork"
              @addFile="(...args)=>this.$emit('addFile',...args)"
              @addExistingFiles="(...args)=>this.$emit('addExistingFiles',...args)"
              @retryUploadFile="(...args)=>this.$emit('retryUploadFile',...args)"
              @discardFailedFile="(...args)=>this.$emit('discardFailedFile',...args)"
              @saveFormData="()=> {if (!customMode.selection.network && !customMode.selection.page) $emit('saveFormData', null, 'form1')}"
              @personsIdentifiedRemoved="(id)=>{if (!customMode.active) $emit('personsIdentifiedRemoved', id, null)}"
              @personsIdentifiedMigrated="(payload)=>{if (!customMode.active) $emit('personsIdentifiedMigrated', payload, null)}"
              @start-edit-video="startEditVideoOrigin"
              @start-edit-image="startEditImage"
              @convert-image-to-video="onConvertImageToVideo"
              :files="files"
              :typeRenderNetworkSelected="typeNetworkSelected"
              :formData="formData"
              :networksSelected="networksSelected"
              :mediaEditorData="currentMediaEditorData"
              :mediaEditorEnabled="isMediaEditorEnabled"
              :mentionsOverSafeLimitByPage="mentionsOverSafeLimitByPage"
            >
            </Form>
          </div>
        </div>
      </div>

      <div class="container-phone" ref="containerPhone">
        <div class="nav-type-network" v-if="!customMode.active">
          <div class="list-network">
            <template v-for="networkName in listNetworkSort">
              <Tooltip
                :key="networkName"
                v-if="networksSelected.includes(networkName)"
                :text="
                                    mode == 'update' && !editableNetworks.includes(networkName) ? $t('dash.post-creator.error.network-edit-impossible') :
                                    postNetworkIsValid[networkName].error.length ? postNetworkIsValid[networkName].error[0].textError : ''"
                :active="!postNetworkIsValid[networkName].showRender"
                position="left"
              >
                <div class="network" :class="{active: typeNetworkSelected == networkName, disable : !postNetworkIsValid[networkName].showRender, [networkName] : true}" @click="selectTypeNetwork(networkName)">
                  <Tooltip
                    v-if="
                                            customModeIsAvailable &&
                                            postNetworkIsValid[networkName].showRender &&
                                            (
                                                isNetworkMediaExporting(networkName) ||
                                                (saveAllFormData.networks[networkName] && Object.keys(saveAllFormData.networks[networkName]).length > 0) ||
                                                (countPagePerNetwork[networkName] == 1 && idsPagesEditedForRenderPost.some((pageId) => allPages[pageId].network == networkName))
                                            )
                                        "
                    :text="isNetworkMediaExporting(networkName) ? $t('dash.post-creator.custommode.media-exporting') : $t('dash.post-creator.custommode.see-changes')"
                    position="right"
                    :classCustom="isNetworkMediaExporting(networkName) ? 'icon-edited exporting-media' : 'icon-edited'"
                    @click="()=>{
                                            handleChangecustomMode(true, networkName); }"
                  />

                  <svg v-if="networkName == 'bluesky'" viewBox="0 0 640 640"><path d="M439.8 358.7C436.5 358.3 433.1 357.9 429.8 357.4C433.2 357.8 436.5 358.3 439.8 358.7zM320 291.1C293.9 240.4 222.9 145.9 156.9 99.3C93.6 54.6 69.5 62.3 53.6 69.5C35.3 77.8 32 105.9 32 122.4C32 138.9 41.1 258 47 277.9C66.5 343.6 136.1 365.8 200.2 358.6C203.5 358.1 206.8 357.7 210.2 357.2C206.9 357.7 203.6 358.2 200.2 358.6C106.3 372.6 22.9 406.8 132.3 528.5C252.6 653.1 297.1 501.8 320 425.1C342.9 501.8 369.2 647.6 505.6 528.5C608 425.1 533.7 372.5 439.8 358.6C436.5 358.2 433.1 357.8 429.8 357.3C433.2 357.7 436.5 358.2 439.8 358.6C503.9 365.7 573.4 343.5 593 277.9C598.9 258 608 139 608 122.4C608 105.8 604.7 77.7 586.4 69.5C570.6 62.4 546.4 54.6 483.2 99.3C417.1 145.9 346.1 240.4 320 291.1z"/></svg>
                  <svg v-else-if="networkName == 'threads'" viewBox="0 0 192 192" width="100%" height="100%"><path d="M141.537 88.9883C140.71 88.5919 139.87 88.2104 139.019 87.8451C137.537 60.5382 122.616 44.905 97.5619 44.745C97.4484 44.7443 97.3355 44.7443 97.222 44.7443C82.2364 44.7443 69.7731 51.1409 62.102 62.7807L75.881 72.2328C81.6116 63.5383 90.6052 61.6848 97.2286 61.6848C97.3051 61.6848 97.3819 61.6848 97.4576 61.6855C105.707 61.7381 111.932 64.1366 115.961 68.814C118.893 72.2193 120.854 76.925 121.825 82.8638C114.511 81.6207 106.601 81.2385 98.145 81.7233C74.3247 83.0954 59.0111 96.9879 60.0396 116.292C60.5615 126.084 65.4397 134.508 73.775 140.011C80.8224 144.663 89.899 146.938 99.3323 146.423C111.79 145.74 121.563 140.987 128.381 132.296C133.559 125.696 136.834 117.143 138.28 106.366C144.217 109.949 148.617 114.664 151.047 120.332C155.179 129.967 155.42 145.8 142.501 158.708C131.182 170.016 117.576 174.908 97.0135 175.059C74.2042 174.89 56.9538 167.575 45.7381 153.317C35.2355 139.966 29.8077 120.682 29.6052 96C29.8077 71.3178 35.2355 52.0336 45.7381 38.6827C56.9538 24.4249 74.2039 17.11 97.0132 16.9405C119.988 17.1113 137.539 24.4614 149.184 38.788C154.894 45.8136 159.199 54.6488 162.037 64.9503L178.184 60.6422C174.744 47.9622 169.331 37.0357 161.965 27.974C147.036 9.60668 125.202 0.195148 97.0695 0H96.9569C68.8816 0.19447 47.2921 9.6418 32.7883 28.0793C19.8819 44.4864 13.2244 67.3157 13.0007 95.9325L13 96L13.0007 96.0675C13.2244 124.684 19.8819 147.514 32.7883 163.921C47.2921 182.358 68.8816 191.806 96.9569 192H97.0695C122.03 191.827 139.624 185.292 154.118 170.811C173.081 151.866 172.51 128.119 166.26 113.541C161.776 103.087 153.227 94.5962 141.537 88.9883ZM98.4405 129.507C88.0005 130.095 77.1544 125.409 76.6196 115.372C76.2232 107.93 81.9158 99.626 99.0812 98.6368C101.047 98.5234 102.976 98.468 104.871 98.468C111.106 98.468 116.939 99.0737 122.242 100.233C120.264 124.935 108.662 128.946 98.4405 129.507Z"/></svg>
                  <svg v-else-if="networkName == 'twitter'" viewBox="0 0 300 271" width="100%" height="100%"><path d="m236 0h46l-101 115 118 156h-92.6l-72.5-94.8-83 94.8h-46l107-123-113-148h94.9l65.5 86.6zm-16.1 244h25.5l-165-218h-27.4z"/></svg>
                  <i v-else-if="networkName == 'linkedin'" class="fa-brands fa-linkedin-in"></i>
                  <i v-else :class="`fa-brands fa-${networkName}`"></i>
                </div>
              </Tooltip>
            </template>

          </div>
        </div>

        <!-- switch entre post standard ou parte en story dans la preview -->
        <div class="switch-preview-post-type" v-if="previewMode.active && previewMode.pageSelected && previewMode.pageSelected.network == 'instagram' && pagesInstagramActivedShareStory.some((page) => page.id == previewMode.pageSelected.id)">
          <div class="btn-primary">Standard</div>
          <div class="" @click.stop="()=>$emit('changeTab','story_share')">Story</div>
        </div>

        <Phone :firstPlan="phoneIsFirstPlan" :currentScopeKey="currentMediaEditorScopeKey">
          <renderPostFailed
            v-if="textPostFailed"
            :textError="textPostFailed"
          />

          <renderPostManager
            :typeNetworkSelected="typeNetworkSelected"
            :formData="formData"
            :formDataPatch="formDataPatch"
            :files="files"
            :pages="pageForRenderPost"
            :idsPagesStatusEdited="pageForRenderPost.length > 1 ? idsPagesEditedForRenderPost : []"
            :featuredPageId="featuredPageIdByNetwork[typeNetworkSelected] || null"
            :positionFormOverlay="customMode.active ? 'right' : 'left'"
            :modes="modes"
            @clickPageInRenderPost="clickPageInRenderPost"
            @featurePageInRenderPost="featurePageInRenderPost"

          />


          <!-- overlay -->
          <selectMention v-if="modes.includes('addMentionMode')"
                         @close="removeMode"
                         :position="customMode.active ? 'right' : 'left'"
                         :mentionData="dataMode.addMentionMode && dataMode.addMentionMode.mention ? dataMode.addMentionMode.mention : {}"
                         :idMention="dataMode.addMentionMode && dataMode.addMentionMode.idMention ? dataMode.addMentionMode.idMention : null"
                         :networks="dataMode.addMentionMode && dataMode.addMentionMode.networks ? dataMode.addMentionMode.networks : null"
                         :text="dataMode.addMentionMode && dataMode.addMentionMode.text ? dataMode.addMentionMode.text : null"
                         :mentions="formData.mentions"
                         :close="dataMode.addMentionMode && dataMode.addMentionMode.close ? dataMode.addMentionMode.close : null"
                         :searchMention="dataMode.addMentionMode && dataMode.addMentionMode.searchMention ? dataMode.addMentionMode.searchMention : null"
                         :removeMention="dataMode.addMentionMode && dataMode.addMentionMode.removeMention ? dataMode.addMentionMode.removeMention : null"
                         :addMention="dataMode.addMentionMode && dataMode.addMentionMode.addMention ? dataMode.addMentionMode.addMention : null"
          />
          <selectHashtag v-if="modes.includes('addHashtagMode')"
                         @close="removeMode"
                         :position="customMode.active ? 'right' : 'left'"
                         :id="dataMode.addHashtagMode && dataMode.addHashtagMode.id ? dataMode.addHashtagMode.id : ''"
                         :searchHashtags="dataMode.addHashtagMode && dataMode.addHashtagMode.searchHashtags ? dataMode.addHashtagMode.searchHashtags : null"
                         :apply="dataMode.addHashtagMode && dataMode.addHashtagMode.apply ? dataMode.addHashtagMode.apply : null"
          />
          <selectVariable v-if="modes.includes('addVariableMode')"
                         @close="removeMode"
                         :position="customMode.active ? 'right' : 'left'"
                         :apply="dataMode.addVariableMode && dataMode.addVariableMode.apply ? dataMode.addVariableMode.apply : null"
                         :currentVariableId="dataMode.addVariableMode && dataMode.addVariableMode.currentVariableId ? dataMode.addVariableMode.currentVariableId : null"
          />

          <inputOverlay
            v-if="modes.includes('inputMode')"
            v-bind="dataMode.inputMode"
            :position="customMode.active ? 'right' : 'left'"
            @close="removeMode"
          />
        </Phone>

        <div class="nav-page-standard" v-if="previewMode.active">
          <div class="list-page hide-scrollbar">
            <template v-for="(networkName, index) in listNetworkSort">
              <div
                class="group"
                v-if="pagesSelected.some(p => p.network == networkName) && (mode !== 'update' || editableNetworks.includes(networkName))"
                :key="networkName"
                :class="{'active': !customMode.active && customMode.selection.network && customMode.selection.network == networkName}"
              >
                <div class="network"
                     :class="{
                                        [networkName]:true,
                                        edited: saveAllFormData.networks[networkName] && Object.keys(saveAllFormData.networks[networkName]).length > 0,
                                        'exporting-media': isScopeMediaExporting('network:' + networkName),
                                        failed: previewMode.active && pagesSelected.some(page => page.network == networkName && dataFormRequest[page.id] &&  dataFormRequest[page.id].error)
                                    }"

                     @click="()=>{
                                        $emit('changePreviewDisplay',true, pagesSelected.find(p => p.network == networkName));
                                        toggleSelectPageForcustomMode(pagesSelected.find(p => p.network == networkName));
                                    }"

                >
                  <Checkbox v-if="!previewMode.active && (!customMode.selection.network || customMode.selection.network !== networkName)" :isChecked="customMode.selection.network && customMode.selection.network == networkName" :add="selectNetworkForcustomMode" :isDisable="customMode.selection.network && customMode.selection.network == networkName" :prefexId="'networkcustomModePostCreator'+index" :id="networkName"></Checkbox>
                </div>
                <div class="list-avatar">
                  <div class="container-avatar"
                       v-for="page in pagesSelected.filter(p => p.network == networkName)"
                       :class="{
                                            checked: (previewMode.pageSelected && previewMode.pageSelected.id == page.id),
                                            edited: !previewMode.active && saveAllFormData.pages[page.id] && Object.keys(saveAllFormData.pages[page.id]).length > 0,
                                            'exporting-media': isScopeMediaExporting('page:' + page.id),
                                            failed: previewMode.active && dataFormRequest[page.id] && dataFormRequest[page.id].error
                                        }"
                       :key="page.id"
                  >

                    <Tooltip :text="page.name" :active="true" position="right">
                      <Avatar
                        @click="()=>{
                                                $emit('changePreviewDisplay',true, page);
                                                toggleSelectPageForcustomMode(page);
                                            }"
                        :checkIsPossible="true"
                        :checked="(previewMode.pageSelected && previewMode.pageSelected.id == page.id)"
                        :urlPicture="page.avatar"
                      />
                    </Tooltip>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>

        <div class="nav-page-standard" v-else>
          <div class="list-page hide-scrollbar">
            <template v-for="(networkName, index) in listNetworkSort">
              <div
                class="group"
                v-if="
                                    customModeIsAvailable && customModeIsAvailable.includes(networkName) &&
                                    (mode !== 'update' || editableNetworks.includes(networkName))
                                "
                :key="networkName"
                :class="{'active': customMode.active && customMode.selection.network && customMode.selection.network == networkName}"
              >
                <div class="network"
                     :class="{
                                        [networkName]:true,
                                        edited: saveAllFormData.networks[networkName] && Object.keys(saveAllFormData.networks[networkName]).length > 0,
                                        'exporting-media': isScopeMediaExporting('network:' + networkName),
                                        failed: previewMode.active && pagesSelected.some(page => page.network == networkName && dataFormRequest[page.id] &&  dataFormRequest[page.id].error)
                                    }"
                     @click="() => selectNetworkForcustomMode(networkName)"
                >
                  <Checkbox v-if="!previewMode.active && (!customMode.selection.network || customMode.selection.network !== networkName)" :isChecked="customMode.selection.network && customMode.selection.network == networkName" :add="selectNetworkForcustomMode" :isDisable="customMode.selection.network && customMode.selection.network == networkName" :prefexId="'networkcustomModePostCreator'+index" :id="networkName"></Checkbox>
                </div>
                <div class="list-avatar" v-if="countPagePerNetwork[networkName] > 1 || idsPagesEditedForRenderPost.some((pageId) => allPages[pageId].network == networkName)">
                  <div class="container-avatar"
                       v-for="page in pagesSelected.filter(p => p.network == networkName)"
                       :class="{
                                            checked: (customMode.selection.page && customMode.selection.page.id == page.id) || (customMode.selection.network && customMode.selection.network == networkName),
                                            edited: !previewMode.active && saveAllFormData.pages[page.id] && Object.keys(saveAllFormData.pages[page.id]).length > 0,
                                            'exporting-media': isScopeMediaExporting('page:' + page.id),
                                            failed: previewMode.active && dataFormRequest[page.id] && dataFormRequest[page.id].error
                                        }"
                       :key="page.id"
                  >
                    <Tooltip :text="page.name" :active="true" position="right">
                      <Avatar @click="()=>toggleSelectPageForcustomMode(page)"
                              :checkIsPossible="true"
                              :checked="(customMode.selection.page && customMode.selection.page.id == page.id) || (customMode.selection.network && customMode.selection.network == networkName)"
                              :urlPicture="page.avatar"
                      />
                    </Tooltip>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>

      <template v-if="formShow == 'formUnique'" >

        <div class="container-form">
          <div class="container-form-scroll hide-scrollbar" style="align-items: flex-end">
            <div class="form">
              <Form
                ref="form"
                :typeRenderNetworkSelected="customMode.selection.network ? customMode.selection.network : customMode.selection.page ? customMode.selection.page.network : typeNetworkSelected"
                :idPageRenderNetworkSelected="customMode.selection.page && customMode.selection.page.id ? customMode.selection.page.id : null"
                :formData="formData"
                @addFile="(...args)=>this.$emit('addFile',...args)"
                @addExistingFiles="(...args)=>this.$emit('addExistingFiles',...args)"
                @retryUploadFile="(...args)=>this.$emit('retryUploadFile',...args)"
                @discardFailedFile="(...args)=>this.$emit('discardFailedFile',...args)"
                :files="files"
                :personalizationMode="true"
                :updateFormData="customMode.selection.network ? saveAllFormData.networks[customMode.selection.network] : customMode.selection.page ? saveAllFormData.pages[customMode.selection.page.id] : {}"
                :networksSelected="networksSelected"
                :mediaEditorData="currentMediaEditorData"
                :mediaEditorEnabled="isMediaEditorEnabled"
                :mentionsOverSafeLimitByPage="mentionsOverSafeLimitByPage"
                @setSelectTypeRenderNetwork="selectTypeNetwork"
                @saveFormData="()=> {if (customMode.selection.network || customMode.selection.page) $emit('saveFormData', customMode.selection.network || customMode.selection.page, 'form2')}"
                @restoreFormData="(key)=> $emit('restoreFormData', key, customMode.selection.network || customMode.selection.page)"
                @personsIdentifiedRemoved="(id)=>{if (customMode.active) $emit('personsIdentifiedRemoved', id, customMode.selection.network || customMode.selection.page)}"
                @personsIdentifiedMigrated="(payload)=>{if (customMode.active) $emit('personsIdentifiedMigrated', payload, customMode.selection.network || customMode.selection.page)}"
                @start-edit-video="startEditVideoOrigin"
                @start-edit-image="startEditImage"
                @convert-image-to-video="onConvertImageToVideo"
              />
            </div>
          </div>
        </div>
        <div></div>
      </template>
    </div>
    <!-- One portal per active scope/session (see activeMediaEditorSessions) - lets an export
         started from the general form and one started from a page/network personalization run
         truly in parallel, and lets a superseded session (re-edited in place, see startEditVideoOrigin)
         keep exporting invisibly in the background until its own finished/export-failed arrives
         and gets discarded (see endEditMedia's "still the active session?" check). -->
    <portal
      v-for="session in activeMediaEditorSessions"
      :key="session.scopeKey + '::' + session.sessionId"
      to="media-editor-dash"
      v-if="files[session.fileIdOrigin] && files[session.fileIdOrigin].url"
    >
      <!-- No <transition> here (unlike the single-session portals elsewhere) - with several of
           these mounted at once, portal-vue's shared target combines all their vnodes into ONE
           render pass, and several simultaneous <transition> siblings there proved to confuse
           Vue's reconciliation: closing out one session's portal was observed destroying an
           unrelated, still-exporting session's <MediaEditor> in the same pass (confirmed via
           instrumentation - its beforeDestroy fired with exporting=true). Each <MediaEditor> is
           already uniquely keyed, which is enough on its own to keep sessions independent. -->
      <MediaEditor
        :key="session.scopeKey + '::' + session.sessionId"
        :videoSrc="files[session.fileIdOrigin].url"
        :localFile="files[session.fileIdOrigin].localFile"
        :timelineState="session.timelineState ? JSON.parse(session.timelineState) : null"
        :extraFiles="session.extraFiles"
        :networksSelected="networksSelected"
        :originSourceType="files[session.fileIdOrigin] ? files[session.fileIdOrigin].info.type2 : 'video'"
        :originIsGif="files[session.fileIdOrigin] ? files[session.fileIdOrigin].info.type === 'image/gif' : false"
        :startMode="startModeForSession(session)"
        :scopeKey="session.scopeKey"
        @finished="e => endEditMedia(session.scopeKey, session.sessionId, e)"
        @export-start="e => onExportStart(session.scopeKey, session.sessionId, e)"
        @export-progress="p => onExportProgress(session.scopeKey, session.sessionId, p)"
        @export-failed="e => onExportFailed(session.scopeKey, session.sessionId, e)"
        @clickOutside="closeMediaEditorSession(session.scopeKey, session.sessionId)"
      />
    </portal>
  </div>
</template>

<script>
import { EventBus } from '@/event-bus';
import store from '@/store/index.js';
import ComponentSwitch from '@/components/dash/utils/switch.vue';
import Avatar from '../utils/avatar.vue';
import Checkbox from '@/components/dash/utils/checkbox.vue';
import Phone from './components/Phone.vue';
import Form from './components/standardTab/Form.vue';
import selectMention from './components/formOverlay/selectMention.vue'
import selectHashtag from './components/formOverlay/selectHashtag.vue'
import selectVariable from './components/formOverlay/selectVariable.vue'
import input from './components/formOverlay/input.vue'
import Tooltip from '@/components/dash/tooltip/tooltipInit.vue'
import renderPostManager from './components/standardTab/RenderPostManager.vue';
import ContextMenu from '@/components/dash/contextMenu/contextMenuInit.vue'
import renderPostFailed from "./components/standardTab/renderPost/renderPostFailed.vue"
import TemplatePicker from '@/components/dash/shared/TemplatePicker.vue'
import TemplateTrigger from '@/components/dash/shared/TemplateTrigger.vue'
import { lazyComponent } from '@/utils/appVersion'
// Lazy-loaded: pulls in fabric.js + mediabunny, only needed once someone actually edits a video.
// Lives at StandardTab.vue level (not inside Form.vue) so a background export survives switching
// between standard/personalization mode, which destroys/recreates whichever Form instance is
// active - see the mediaEditorData state and startEditVideoOrigin/endEditMedia below.
const MediaEditor = lazyComponent(() => import('@/components/dash/mediaEditor/MediaEditor.vue'));


import { listNetworkSort,  formDataDefault, editableNetworks, maxMentionsSafeByNetwork} from './constante.js'
import {
  postNetworkValidator,
  getFilesByNetwork,
  deepClone,
  mergeUpdates,
  unescapeSpecialChars,
  customModeIsAvailable as customModeIsAvailableUtil,
  getPlanifiedDateISO,
  matchesVideoOrigin,
  getMentionsOverSafeLimit,
  allInstagramNative,
  getFeaturedPage
} from './utils.js'

import postMixin from '@/components/mixins/Posts.vue'
import draftMixin from '@/components/mixins/Drafts.vue'
import PostCreatorMixin from './mixins/main.js';
import TemplatesFeatureFlag from '@/components/mixins/TemplatesFeatureFlag.vue'

export default {
  components: {
    ComponentSwitch,
    Phone,
    Form,
    Avatar,
    Checkbox,
    selectMention,
    selectHashtag,
    selectVariable,
    inputOverlay: input,
    renderPostFailed,
    renderPostManager,
    Tooltip,
    ContextMenu,
    MediaEditor,
    TemplateTrigger,
    TemplatePicker
  },
  mixins: [postMixin, draftMixin, PostCreatorMixin, TemplatesFeatureFlag],

  props: {
    mode: String,
    tab: String,
    files: Object,
    isFileUploading:Boolean,
    hasFailedUpload: Boolean,
    isSavingDraft: Boolean,
    formData: Object,
    saveAllFormData: Object,
    dataFormRequest: Object,
    previewMode: Object,
    idUsersAssigned:Array,
    requiredValidation:Boolean,
    canRestoreDraft:Boolean,
    isMongoDraftEdit: { type: Boolean, default: false },
  },

  data() {
    return {

      listNetworkSort,
      editableNetworks,

      showPostTemplatePicker: false,
      postTemplateAction: 'apply',

      // page mise en avant (au-dessus de la pile d'avatars) par réseau, choisie explicitement
      // par l'utilisateur - cf. setFeaturedPage/getFeaturedPage. En mémoire uniquement, non
      // persistée : repart à vide à chaque nouvelle session de post creator.
      featuredPageIdByNetwork: {},

      customMode: {
        active : false,
        selection : {
          network: null,
          page: null
        }

      },

      formShow: "formMultiple",// pour l'annimation
      timeOutAnnimateForm: null,
      typeNetworkSelected: "", //pour le telphone donc renomer la variable

      // Moved up from Form.vue (see Form.vue's mediaEditorEnabled/mediaEditorData props) - a
      // background video export must survive switching between formShow's two mutually exclusive
      // <Form> instances (standard/personalization), which destroy/recreate whichever one isn't
      // currently shown. StandardTab.vue itself is never destroyed by that toggle, so this - and
      // the <MediaEditor> portal in the template - live here instead.
      //
      // Keyed by "scope" (see currentMediaEditorScopeKey) rather than a single shared object, so
      // an export started from the general form and one started from a page/network
      // personalization can run truly in parallel without clobbering each other - and so
      // re-editing a video that's still exporting *in the same scope* opens a fresh session
      // instead of being blocked, while the superseded one keeps exporting quietly in the
      // background until it resolves (see endEditMedia's "still the active session?" check).
      mediaEditorSessions: {}, // "scopeKey::sessionId" -> { scopeKey, sessionId, fileIdOrigin, fileId, timelineState, extraFiles, exporting, exportProgress, jobId }
      mediaEditorActiveSessionByScope: {}, // scopeKey -> the sessionId currently shown/reopenable for that scope
      mediaEditorNextSessionId: 1,

      // jobId -> true for every mediaExportJobs job "claimed" by a pending publish (see
      // PostCreator.vue's sendPostAllPost/claimMediaExportJobIds) - endEditMedia/onExportFailed
      // become no-ops for a claimed job, since the deferred-publish path (PostCreator.vue +
      // mediaExportJobs.js's registerPendingPublish) exclusively owns applying that job's result
      // once it resolves, whether or not the user is still sitting on this same scope.
      claimedMediaJobIds: {},


      //la list mode est connu et modifiable par tout les interfaces Network et les deux formulaires
      modes : [],
      dataMode : {},

      showTutorial : !localStorage.postCreatorCountUsecustomMode ? true : localStorage.postCreatorCountUsecustomMode < 3,

      pagesInstagramActivedShareStory: []
    }
  },

  mounted() {
    EventBus.$on('postCreatorAddMode', this.addMode);
    EventBus.$on('postCreatorRemoveMode', this.removeMode);
    this.updateTypeNetworkSelected()
    this.setPagesInstagramActivedShareStory()
    this.$store.dispatch('variables/fetchVariables')
  },

  methods: {
    onApplyPostTemplate(template) {
      this.showPostTemplatePicker = false
      this.$emit('applyPostTemplate', template)
    },

    goBackToPlanner() {
      if (this.isDemo) return // /dash/posts2 requires a real session - would bounce to signup
      this.$router.push({ name: 'posts2', params: { date: getPlanifiedDateISO(this.formData.planifiedDate), scrollToHour: true } })
    },

    clickContextMenuPage(name, page) {
      switch (name) {
        case 'removePage':
          this.removePage(page.id)
          break;
        case 'customPage':
          if (this.customModeIsAvailable)  this.handleChangecustomMode(true, null, page)

          break;
        case 'featurePage':
          this.setFeaturedPage(page)
          break;
      }
    },

    // menu contextuel de la frise de pages sélectionnées : "Voir le post sur cette page"
    // n'a de sens que s'il y a plusieurs pages du même réseau (sinon rien à mettre en avant)
    pageContextMenuOptions(page) {
      const options = []

      if (this.pagesSelected.filter(p => p.network === page.network).length > 1) {
        options.push({ label: this.$t('dash.post-creator.pages.feature'), name: 'featurePage' })
      }
      if (this.customModeIsAvailable) options.push({ label: this.$t('dash.post-creator.pages.customize'), name: 'customPage' })
      options.push({ label: this.$t('dash.post-creator.pages.remove'), name: 'removePage' })

      return options
    },

    // met `page` en haut de la pile d'avatars de l'aperçu pour son réseau (choix explicite
    // de l'utilisateur, via la frise ou directement depuis l'aperçu) - cf. getFeaturedPage.
    // Depuis la frise, la page choisie peut appartenir à un réseau différent de l'onglet
    // actuellement affiché dans l'aperçu : on bascule alors aussi sur cet onglet.
    setFeaturedPage(page) {
      this.$set(this.featuredPageIdByNetwork, page.network, page.id)
      if (this.typeNetworkSelected !== page.network) this.selectTypeNetwork(page.network)
    },

    featurePageInRenderPost(pageId) {
      const page = this.pagesSelected.find(p => p.id == pageId)
      if (page) this.setFeaturedPage(page)
    },

    ///////////// METHOD SWITCH MODE /////////////

    handleChangecustomMode(state, network = null, page = null) {
      this.$set(this.customMode, 'active' ,state)
      if (state) {
        if (!network && !page) network = this.typeNetworkSelected || [...this.networksSelected][0]

        // Renseigné ici de façon synchrone (en plus de selectNetworkForcustomMode/
        // toggleSelectPageForcustomMode plus bas, qui refont le même $set - sans effet de bord,
        // juste redondant - en plus de generateFormData) pour éviter la fenêtre de ~200ms où
        // customMode.active est déjà true mais selection.page ET selection.network sont encore
        // tous les deux null (le temps que le setTimeout plus bas s'exécute). Pendant cette
        // fenêtre, pageForRenderPost (computed plus bas) renvoyait [] ou un crash en aval selon
        // le composant de rendu réseau concerné (RenderReelFacebook.vue etc. lisent pages[0]
        // sans vérifier la longueur) - un crash de rendu qui interrompt le patch Vue en plein
        // switch de mode, ce qui peut laisser la preview (et la barre de progression de l'export
        // vidéo qu'elle affiche) bloquée sur son dernier état affiché avec succès.
        if (page) {
          this.$set(this.customMode.selection, 'network', null)
          this.$set(this.customMode.selection, 'page', page)
        } else if (network) {
          this.$set(this.customMode.selection, 'page', null)
          this.$set(this.customMode.selection, 'network', network)
        }

        console.log('test12 handleChangecustomMode', state)
        this.$emit("saveFormData")
        if (this.$refs.postCreator && this.$refs.postCreator.classList) {
          this.$refs.postCreator.classList.add('annimate-switch-edition-mode');
        }
        if (this.$refs.postCreator && this.$refs.postCreator.style) {
          this.$refs.postCreator.style.transform = `translateX(calc(-100% + ${this.$refs.containerPhone ? this.$refs.containerPhone.clientWidth : 0}px))`
        }

        if (this.timeOutAnnimateForm) clearTimeout(this.timeOutAnnimateForm)

        this.timeOutAnnimateForm = setTimeout(() => {
          if (network) {
            this.typeNetworkSelected = network
            this.selectNetworkForcustomMode(network)
          }else if (page) {
            this.toggleSelectPageForcustomMode(page)
          }
          this.timeOutAnnimateForm = setTimeout(() => {
            if (this.$refs.postCreator && this.$refs.postCreator.classList) {
              this.$refs.postCreator.classList.remove('annimate-switch-edition-mode');
            }
            if (this.$refs.postCreator && this.$refs.postCreator.style) {
              this.$refs.postCreator.style.transform = ``
            }
            this.formShow = "formUnique"
          }, 300);
        }, 200);

        if (!localStorage.postCreatorCountUsecustomMode || localStorage.postCreatorCountUsecustomMode < 3) {
          if (!localStorage.postCreatorCountUsecustomMode) localStorage.setItem('postCreatorCountUsecustomMode', 1)
          else localStorage.setItem('postCreatorCountUsecustomMode', localStorage.postCreatorCountUsecustomMode + 1)
        }

      }else{
        if (this.$refs.postCreator && this.$refs.postCreator.classList) {
          this.$refs.postCreator.classList.add('annimate-switch-edition-mode');
        }
        if (this.$refs.postCreator && this.$refs.postCreator.style) {
          this.$refs.postCreator.style.transform = `translateX(calc(100% - ${this.$refs.containerPhone ? this.$refs.containerPhone.clientWidth : 0}px))`
        }
        if (this.timeOutAnnimateForm) clearTimeout(this.timeOutAnnimateForm)

        this.$nextTick(() => {
          this.timeOutAnnimateForm = setTimeout(() => {

            this.timeOutAnnimateForm = setTimeout(() => {
              if (this.$refs.postCreator && this.$refs.postCreator.classList) {
                this.$refs.postCreator.classList.remove('annimate-switch-edition-mode');
              }
              if (this.$refs.postCreator && this.$refs.postCreator.style) {
                this.$refs.postCreator.style.transform = ``
              }
              this.formShow = "formMultiple" //detruit le form de droite
              this.generateFormData() //gerner le new form data le form de droite, si inverte le form de droite va vouloir save
            }, 300);
          }, 200);
        })
      }
    },

    async handlerChangePreviewDisplay(state) {
      if (state) {
        if (!this.isFileUploading) {
          this.$emit('saveFormData', this.customMode.active ? this.customMode.selection.page || this.customMode.selection.network : null)
          this.generateStoryShare()
        }
      }else{
        this.generateFormData(this.customMode.active ? this.customMode.selection.page || this.customMode.selection.network : null)
      }

      this.$emit('changePreviewDisplay',state)
    },

    selectNetworkForcustomMode(network) {
      if (this.previewMode.active) return
      this.$set(this.customMode.selection, 'page', null)
      this.$set(this.customMode.selection, 'network', network)
      this.typeNetworkSelected = network
      this.generateFormData(network)
    },

    toggleSelectPageForcustomMode(page) {
      //  this.$emit('saveFormData')
      this.$set(this.customMode.selection, 'network', null)
      this.$set(this.customMode.selection, 'page', page)
      this.typeNetworkSelected = page.network
      this.generateFormData(page)
    },

    clickPageInRenderPost(idPage) {
      const page = this.pagesSelected.find(p => p.id == idPage)
      if (page) {
        if (this.customMode.active) {
          this.toggleSelectPageForcustomMode(page)
        }else{
          this.handleChangecustomMode(true, null, page)
        }
      }
    },

    generateFormData(pageOrNetwork) {
      this.$emit('generateFormData', this.customModeIsAvailable ? pageOrNetwork : null)
    },

    ///////////// METHOD NAVIGATION /////////////

    switchTab(tabName) {

      this.$emit('saveFormData', this.customMode.active ? this.customMode.selection.page || this.customMode.selection.network : null)

      if (tabName == 'story_share') {
        this.generateStoryShare()
        this.generateFormData()
      }else{
        if (this.pagesSelected.some(p=> p.network !== 'instagram' && !(p.network === 'facebook' && p.story_config && p.story_config.created)) || this.hasMixedStoryNetworks) return

        if (tabName == 'story') {
          this.removeAllStickersPost()
          // if (this.saveAllFormData.main.storification['0'] && Object.keys(this.saveAllFormData.main.storification).length == 1 && !this.saveAllFormData.main.storification['0'].background.file) {
          //     let file = this.saveAllFormData.main.files.find(({id:idFile}) => (this.files[idFile] && ['video','image'].includes(this.files[idFile].info.type2) && this.files[idFile].info.type !== 'image/gif'))

          //     if (file) {
          //         file = this.files[file.id]
          //         this.$set(this.saveAllFormData.main.storification['0'], 'background',
          //             {
          //                 file: {"id": file.id},
          //                 color: file.info.averageColor,
          //                 size: file.info.aspectRatio > 0.5625 ? 'containX' : 'containY',
          //                 position: {"x":50,"y":50},
          //                 transform: {"rotate":0,"scale":1}
          //             }
          //         )
          //     }
          // }
          this.generateFormData()
        }
      }
      this.$emit("changeTab",tabName)
    },

    selectTypeNetwork(typeNetwork) {
      if (this.mode == 'update' && !editableNetworks.includes(typeNetwork)) return
      if (!this.postNetworkIsValid[typeNetwork] || !this.postNetworkIsValid[typeNetwork].showRender) return
      this.typeNetworkSelected = typeNetwork
    },

    // Walks currentMediaEditorScopeChain (most to least specific) for the first scope that has an
    // active session - optionally only counting one for a specific fileId. Shared by
    // currentMediaEditorData (no filter - just "what's the nearest in-progress session, if any")
    // and startEditVideoOrigin (filtered - "is THIS exact video already being edited/exported somewhere
    // up the chain, so a re-edit here should resume from that instead of the original upload").
    resolveInheritedMediaEditorSession(fileIdFilter) {
      for (const scopeKey of this.currentMediaEditorScopeChain) {
        const sessionId = this.mediaEditorActiveSessionByScope[scopeKey]
        const session = sessionId && this.mediaEditorSessions[scopeKey + '::' + sessionId]
        if (session && (fileIdFilter == null || session.fileId === fileIdFilter)) return session
      }
      return null
    },

    // Drives the "en cours d'export" spinner on a network/page's avatar in the nav (see
    // nav-page-standard below) - only THIS exact scope's own active session, no inheritance up
    // currentMediaEditorScopeChain (mirrors how the "edited" pencil badge already only reflects a
    // scope's own saveAllFormData override, never an inherited one).
    isScopeMediaExporting(scopeKey) {
      const sessionId = this.mediaEditorActiveSessionByScope[scopeKey]
      const session = sessionId && this.mediaEditorSessions[scopeKey + '::' + sessionId]
      return !!(session && session.exporting)
    },

    // Same signal for the network selector shown in the GENERAL context (nav-type-network, only
    // one icon per network - no per-page granularity there) - true if the network's own
    // personalization is exporting, or any of its pages' is.
    isNetworkMediaExporting(networkName) {
      if (this.isScopeMediaExporting('network:' + networkName)) return true
      return this.pagesSelected.some(p => p.network === networkName && this.isScopeMediaExporting('page:' + p.id))
    },

    // MediaEditor.vue's startMode prop (see its comment) - session.fileId is the currently-saved
    // file being reopened, so its type decides which mode this reopens in. Null when unresolvable
    // (mid-upload, deleted file); MediaEditor.vue falls back to its own default in that case.
    startModeForSession(session) {
      const current = this.files[session.fileId]
      if (!current) return null
      return current.info.type2 === 'image' && current.info.type !== 'image/gif' ? 'photo' : 'video'
    },

    // Registers a fresh session as THE active one for a scope - shared by startEditVideoOrigin and
    // onConvertImageToVideo. If the session it's taking over from is actually exporting right now
    // (a same-scope re-edit while an export is running), it simply stops being "active" and keeps
    // exporting invisibly (its own <MediaEditor> instance, still mounted via
    // activeMediaEditorSessions, is already hidden behind backgroundExport) until its own
    // finished/export-failed arrives, at which point endEditMedia/onExportFailed notice it's no
    // longer the active session for this scope and discard its result entirely. That's exactly
    // "save the re-edit -> abandon the previous creation" from the user's perspective.
    //
    // A previous session that was never exported has no work worth preserving - discarded here
    // immediately, since left mounted its own clickOutside never fires (the new popup on top
    // permanently blocks the click from reaching its backdrop), staying orphaned forever.
    registerMediaEditorSession(scopeKey, { fileId, fileIdOrigin, timelineState, extraFiles }) {
      const sessionId = this.mediaEditorNextSessionId++
      const previousSessionId = this.mediaEditorActiveSessionByScope[scopeKey] || null
      const previousSessionKey = previousSessionId ? scopeKey + '::' + previousSessionId : null
      const previousSession = previousSessionKey ? this.mediaEditorSessions[previousSessionKey] : null
      if (previousSession && !previousSession.exporting) this.$delete(this.mediaEditorSessions, previousSessionKey)
      const supersedes = previousSession && previousSession.exporting ? previousSessionId : null
      this.$set(this.mediaEditorSessions, scopeKey + '::' + sessionId, {
        scopeKey,
        sessionId,
        supersedes,
        fileId,
        fileIdOrigin,
        timelineState,
        extraFiles,
        exporting: false,
        exportProgress: 0
      })
      this.$set(this.mediaEditorActiveSessionByScope, scopeKey, sessionId)
    },

    // Moved up from Form.vue (see @start-edit-video on both <Form> instances above) - unchanged
    // logic, just living somewhere that survives the standard/personalization toggle now, and now
    // scoped (see currentMediaEditorScopeKey) so a click here always targets whichever
    // general/page/network context is currently on screen, independently of any other scope's
    // export already running - and even independently of an export already running IN THIS SAME
    // scope (no more exporting guard - see registerMediaEditorSession).
    startEditVideoOrigin(fileId) {
      if (!this.isMediaEditorEnabled) return
      if (!this.files[fileId] || !this.files[fileId].url) return
      if (!this.files[fileId].isUpload) return
      if (this.files[fileId].info.type2 !== 'video') return

      const media = this.formData.files.find(f => f.id === fileId)
      if (!media) return

      const scopeKey = this.currentMediaEditorScopeKey
      // Checks this scope first, then its network/general ancestors (see
      // currentMediaEditorScopeChain) - a page with no video session of its own but whose general
      // (or network) is currently editing/exporting this exact video should resume from THAT
      // in-progress state too, exactly like it already inherits that ancestor's text/settings when
      // it has no override of its own yet.
      const inheritedSession = this.resolveInheritedMediaEditorSession(fileId)

      let timelineState = null
      let extraFiles = {}
      let fileIdOrigin = fileId

      if (inheritedSession) {
        // Un export est déjà en cours (ou en cours d'édition) pour ce media dans ce scope ou un
        // scope parent - c'est l'édition la PLUS RÉCENTE, même pas encore terminée/sauvegardée,
        // donc on reprend sur SA base plutôt que sur le dernier export déjà terminé
        // (media.mediaEditorData ci-dessous), sans quoi rééditer pendant un export repartait à
        // tort de la vidéo/timeline d'origine.
        timelineState = inheritedSession.timelineState
        extraFiles = inheritedSession.extraFiles
        fileIdOrigin = inheritedSession.fileIdOrigin
      } else if (media.mediaEditorData && media.mediaEditorData.fileIdOrigin && this.files[media.mediaEditorData.fileIdOrigin] && this.files[media.mediaEditorData.fileIdOrigin].url) {
        if (media.mediaEditorData.timelineState) timelineState = media.mediaEditorData.timelineState
        // Clips/musique ajoutés en plus de la vidéo d'origine (donc pas encore uploadés
        // nulle part ailleurs) doivent être conservés ici pour pouvoir reconstruire la
        // timeline complète à la réouverture - sans ça, chaque clip additionnel devenait
        // irrécupérable et l'éditeur revenait silencieusement à une timeline vierge.
        extraFiles = media.mediaEditorData.extraFiles || {}
        fileIdOrigin = media.mediaEditorData.fileIdOrigin
      }

      this.registerMediaEditorSession(scopeKey, { fileId, fileIdOrigin, timelineState, extraFiles })
    },

    // Mirrors startEditVideoOrigin above, for the image thumbnail's own click (see Form.vue's
    // startEditMedia) - opens MediaEditor in photo mode instead of ImageCropper. Same
    // resume-from-mediaEditorData lookup, so re-editing an already-edited photo resumes its
    // own session exactly like a video does.
    startEditImage(fileId) {
      if (!this.isMediaEditorEnabled) return
      if (!this.files[fileId] || !this.files[fileId].url) return
      if (!this.files[fileId].isUpload) return
      if (this.files[fileId].info.type2 !== 'image') return

      const media = this.formData.files.find(f => f.id === fileId)
      if (!media) return

      const scopeKey = this.currentMediaEditorScopeKey
      const inheritedSession = this.resolveInheritedMediaEditorSession(fileId)

      let timelineState = null
      let extraFiles = {}
      let fileIdOrigin = fileId

      if (inheritedSession) {
        timelineState = inheritedSession.timelineState
        extraFiles = inheritedSession.extraFiles
        fileIdOrigin = inheritedSession.fileIdOrigin
      } else if (media.mediaEditorData && media.mediaEditorData.fileIdOrigin && this.files[media.mediaEditorData.fileIdOrigin] && this.files[media.mediaEditorData.fileIdOrigin].url) {
        if (media.mediaEditorData.timelineState) timelineState = media.mediaEditorData.timelineState
        extraFiles = media.mediaEditorData.extraFiles || {}
        fileIdOrigin = media.mediaEditorData.fileIdOrigin
      }

      this.registerMediaEditorSession(scopeKey, { fileId, fileIdOrigin, timelineState, extraFiles })
    },

    // Bridge from ImageCropper.vue's "Créer une vidéo" button, relayed up through whichever Form
    // instance's own convertImageToVideo (it only closes its local imageCropperData, then emits
    // this). No "resume" lookup like startEditVideoOrigin's, on purpose: once a conversion succeeds,
    // this media's own id is entirely replaced (see endEditMedia) and it stops being an image at
    // all, so this exact media can never already have a mediaEditorData of its own to resume from.
    onConvertImageToVideo({ fileId, fileIdOrigin }) {
      if (!this.isMediaEditorEnabled) return
      this.registerMediaEditorSession(this.currentMediaEditorScopeKey, { fileId, fileIdOrigin, timelineState: null, extraFiles: {} })
    },

    endEditMedia(scopeKey, sessionId, event) {
      const sessionKey = scopeKey + '::' + sessionId
      const session = this.mediaEditorSessions[sessionKey]

      // Claimed by a pending publish (see PostCreator.vue's sendPostAllPost/claimMediaExportJobIds) -
      // that deferred-publish path exclusively owns applying this job's result once it resolves, so
      // this is a pure no-op here: no formData mutation, no Instagram-tag migration, nothing. The
      // session itself is left untouched too (not even concluded) - mediaExportJobs.js already holds
      // the resolved File for the pending publish to consume; there's nothing left for this component
      // to do with it.
      const jobId = (session && session.jobId) || (event && event.jobId)
      if (jobId && this.claimedMediaJobIds[jobId]) return

      // Superseded by a same-scope re-edit since this export started (see
      // registerMediaEditorSession) - the newer edit already won, so this older export's result
      // is discarded entirely, never written anywhere.
      if (this.mediaEditorActiveSessionByScope[scopeKey] !== sessionId) {
        this.$delete(this.mediaEditorSessions, sessionKey)
        return
      }

      // Vidéo finale exportée 100% côté navigateur (WebCodecs/Mediabunny ou repli MediaRecorder) :
      // upload comme un fichier normal, même flow que endEditImage.
      const timelineStateString = JSON.stringify(event.timelineState)
      const file = event.file
      const extraFiles = event.extraFiles || {}
      const id = Math.random().toString(36).substr(2, 9)
      const oldFileId = session ? session.fileId : null
      const fileIdOrigin = session ? session.fileIdOrigin : null

      this.$emit('addFile', null, file, true, id, (filesAdded) => {
        // formData is a prop that can be entirely replaced from underneath us at any time (see
        // PostCreator.vue's generateFormData - notably called when leaving personalization mode,
        // right in the middle of this same toggle a background export is meant to survive). If
        // that leaves this.formData.files in a shape this code doesn't expect, the resulting
        // exception was previously thrown *inside* this callback, straight into uploadFile's own
        // top-level try/catch (PostCreator.vue) - silently swallowed there (logged to Sentry only),
        // which skipped everything below including clearing this session. The result was a
        // progress bar stuck forever, since nothing else ever clears it. try/finally here
        // guarantees the loader always clears, whether or not the write itself succeeded.
        try {
          const newFileEntry = {
            id,
            mediaEditorData: { fileIdOrigin, timelineState: timelineStateString, extraFiles }
          }

          if (scopeKey === this.currentMediaEditorScopeKey) {
            // This scope is the one on screen right now - same path as before this feature:
            // mutate the live formData directly. Matched by fileIdOrigin (stable identity, see
            // matchesVideoOrigin), not the transient oldFileId - a sibling scope inheriting from
            // the same base array can already have replaced that exact id by the time this runs.
            const newFilesFormData = this.formData.files.map(f => matchesVideoOrigin(f, fileIdOrigin) ? newFileEntry : f)
            this.$set(this.formData, 'files', newFilesFormData)

            // Un media converti depuis l'éditeur d'image (voir onConvertImageToVideo) peut avoir des
            // tags de personnes Instagram liés à son ancien id - sans cette migration (déjà faite par
            // endEditImage pour le même remplacement d'id), ils deviendraient orphelins dès qu'une
            // image devient une vidéo.
            if (this.formData.formDataNetwork.instagram?.personsIdentified?.length) {
              this.$set(this.formData.formDataNetwork.instagram, 'personsIdentified', this.formData.formDataNetwork.instagram.personsIdentified.map(p => p.idFile === oldFileId ? { ...p, idFile: id } : p))
            }
            this.$emit('personsIdentifiedMigrated', { oldId: oldFileId, newId: id })

            // notifyUploadFile/formNetwork only make sense against whichever Form instance is
            // actually showing right now (per-network UI refresh) - not necessarily the one that
            // started the export, if it's since been destroyed by a mode switch.
            const activeForm = this.$refs.form
            if (activeForm && activeForm.onMediaReplaced) activeForm.onMediaReplaced([file])

            // this.formData is a transient working copy (see PostCreator.vue's generateFormData -
            // always a deepClone, never the same reference as saveAllFormData) - normally only
            // persisted into saveAllFormData on an explicit navigation event (switching
            // network/page, leaving preview, etc.). An export can conclude long after the user
            // last navigated, while they're just sitting on this same scope watching it finish -
            // without persisting right here, the very next unrelated generateFormData() call
            // (triggered by anything, e.g. switching to yet another page/network) replaces
            // this.formData wholesale from the STILL-UNSAVED saveAllFormData, silently discarding
            // this edit even though it was correctly applied above. Same emit navigation already
            // uses elsewhere (switchTab, handlerChangePreviewDisplay) - just fired immediately
            // instead of waiting for the next one.
            this.$emit('saveFormData', this.customMode.active ? (this.customMode.selection.page || this.customMode.selection.network) : null)
          } else {
            // A different scope than the one currently on screen - this.formData reflects THAT
            // scope right now, not this one, so writing to it would corrupt whatever's visible.
            // PostCreator.vue resolves this scope's own effective files array and patches it
            // directly (see applyBackgroundMediaResult) - matched by fileIdOrigin, not oldFileId
            // (see matchesVideoOrigin above: the base array it falls back to can already have been
            // rewritten by a sibling scope, e.g. general, concluding first).
            this.$emit('applyBackgroundMediaResult', { scopeKey, fileIdOrigin, buildNewEntry: () => newFileEntry })
          }
        } catch (e) {
          console.error('[StandardTab] endEditMedia: failed to apply the exported video', e)
        } finally {
          this.concludeMediaEditorSession(scopeKey, sessionId)
        }
      })
    },

    // Export just started in the background (see MediaEditor.vue's finish()) - the popup is
    // already closed by this point, so this only drives the progress bar on the media thumbnail
    // (see Form.vue's containerProgressBar), and only for the scope currently on screen - a
    // background scope's export has no visible progress bar anywhere, nothing needs updating for it
    // beyond the session bookkeeping itself.
    onExportStart(scopeKey, sessionId, { timelineState, extraFiles, jobId }) {
      const session = this.mediaEditorSessions[scopeKey + '::' + sessionId]
      if (!session) return
      this.$set(session, 'exporting', true)
      this.$set(session, 'exportProgress', 0)
      // Carried by mediaExportJobs.js's job - lets a submit click (see getPendingMediaExportJobIds/
      // claimMediaExportJobIds below) find and claim exactly the job(s) backing whatever's still
      // exporting right now, and lets endEditMedia/onExportFailed recognize a claimed job later.
      this.$set(session, 'jobId', jobId)
      // Snapshot of the edit actually being encoded right now (not whatever was there before this
      // "Terminer" click) - so re-editing while this export is still running (see startEditVideoOrigin's
      // resolveInheritedMediaEditorSession) resumes from the current creation, not the pre-edit state.
      this.$set(session, 'timelineState', JSON.stringify(timelineState))
      this.$set(session, 'extraFiles', extraFiles)

      if (scopeKey !== this.currentMediaEditorScopeKey) return

      // Also clears any error left over from a previous failed attempt on this same media, so a
      // retry doesn't show the old error icon and the new progress bar at the same time.
      // Best-effort only (see endEditMedia's try/finally for why) - formData can be mid-swap here too.
      try {
        const media = this.formData.files.find(f => f.id === session.fileId)
        if (media && media.mediaEditorData && media.mediaEditorData.exportError) {
          this.$set(media.mediaEditorData, 'exportError', null)
        }
      } catch (e) {
        console.error('[StandardTab] onExportStart: failed to clear the previous export error on formData', e)
      }
    },

    onExportProgress(scopeKey, sessionId, progress) {
      const session = this.mediaEditorSessions[scopeKey + '::' + sessionId]
      if (session) this.$set(session, 'exportProgress', progress)
    },

    // The export failed - unlike a success, nothing new gets uploaded, so the post keeps showing
    // the original video. The edits and the error both have to be persisted onto the *original*
    // media entry (not the transient session state, which the next startEditVideoOrigin call wipes) so
    // reopening the editor resumes the same configuration and lets the user retry, and the error
    // icon survives until they do.
    onExportFailed(scopeKey, sessionId, { error, timelineState, extraFiles, jobId }) {
      const sessionKey = scopeKey + '::' + sessionId
      const session = this.mediaEditorSessions[sessionKey]

      // Claimed by a pending publish - same reasoning as endEditMedia's identical check above: the
      // deferred-publish path exclusively owns this job's outcome (mediaExportJobs.js's
      // registerPendingPublish already rejects it there), nothing to persist here.
      const claimedJobId = (session && session.jobId) || jobId
      if (claimedJobId && this.claimedMediaJobIds[claimedJobId]) return

      // Superseded by a same-scope re-edit before this failure even arrived - same as endEditMedia,
      // discard silently, nothing to persist for a session nobody's looking at anymore.
      if (this.mediaEditorActiveSessionByScope[scopeKey] === sessionId) {
        const fileId = session ? session.fileId : null
        const fileIdOrigin = session ? session.fileIdOrigin : null
        const mediaEditorDataPatch = {
          fileIdOrigin,
          timelineState: JSON.stringify(timelineState),
          extraFiles,
          exportError: error
        }

        // Same guarantee as endEditMedia above - the write is best-effort; the loader must clear
        // regardless of whether it succeeds.
        try {
          if (scopeKey === this.currentMediaEditorScopeKey) {
            const newFilesFormData = this.formData.files.map(f => !matchesVideoOrigin(f, fileIdOrigin) ? f : { ...f, mediaEditorData: mediaEditorDataPatch })
            this.$set(this.formData, 'files', newFilesFormData)
            // See endEditMedia's identical emit - persists this into saveAllFormData right away
            // instead of leaving it in the transient formData until the next unrelated navigation.
            this.$emit('saveFormData', this.customMode.active ? (this.customMode.selection.page || this.customMode.selection.network) : null)
          } else {
            // Background scope - still worth persisting so the error icon shows once the user
            // comes back to this scope, same reasoning as endEditMedia's background branch.
            this.$emit('applyBackgroundMediaResult', {
              scopeKey,
              fileIdOrigin,
              buildNewEntry: (existing) => ({ ...(existing || { id: fileId }), mediaEditorData: mediaEditorDataPatch })
            })
          }
        } catch (e) {
          console.error('[StandardTab] onExportFailed: failed to persist the export error', e)
        }
      }

      this.concludeMediaEditorSession(scopeKey, sessionId)
    },

    // Shared by endEditMedia/onExportFailed once a session's result has been applied (or discarded
    // as superseded) - removes it and clears the scope's active pointer if it still pointed here,
    // so a later re-edit in this scope never reads this now-deleted id as what it's superseding.
    concludeMediaEditorSession(scopeKey, sessionId) {
      this.$delete(this.mediaEditorSessions, scopeKey + '::' + sessionId)
      if (this.mediaEditorActiveSessionByScope[scopeKey] === sessionId) {
        this.$delete(this.mediaEditorActiveSessionByScope, scopeKey)
      }
    },

    // Closing the editor popup without exporting (see @clickOutside) - just discards this session
    // entirely. If it was a same-scope re-edit of an already-exporting video, the ORIGINAL export
    // (a different, still-untouched session) simply keeps running, exactly as if this re-edit
    // attempt had never happened.
    closeMediaEditorSession(scopeKey, sessionId) {
      const sessionKey = scopeKey + '::' + sessionId
      const session = this.mediaEditorSessions[sessionKey]
      this.$delete(this.mediaEditorSessions, sessionKey)
      if (this.mediaEditorActiveSessionByScope[scopeKey] === sessionId) {
        // If this was a re-edit of an older, still-running export (see supersedes), hand the scope
        // back to it - otherwise its own finished/export-failed would look superseded (see
        // endEditMedia) and get discarded even though it's meant to keep running untouched.
        if (session && session.supersedes && this.mediaEditorSessions[scopeKey + '::' + session.supersedes]) {
          this.$set(this.mediaEditorActiveSessionByScope, scopeKey, session.supersedes)
        } else {
          this.$delete(this.mediaEditorActiveSessionByScope, scopeKey)
        }
      }
    },

    openSelectPage() {
      this.$store.commit('selectPage/updateSelectPageListRetracted', !this.$store.getters['selectPage/selectPageStateListRetracted'])
    },

    addMode(mode, data = {}) {
      if (!this.modes.includes(mode)) this.modes = [...this.modes,mode]
      this.$set(this.dataMode, mode, data)
    },

    removeMode(mode = 'all') {
      if (mode == 'all') {
        this.modes = []
        return
      }
      this.modes = this.modes.filter(v => v !== mode)
    },

    switchInterface() {
      localStorage.setItem('version_', 'old')
      this.$router.push({
        name: 'planner',
        params: {
          newPost: true
        }
      })
    },

    updateTypeNetworkSelected() {

      if (!this.typeNetworkSelected || !this.networksSelected.includes(this.typeNetworkSelected) || (!this.postNetworkIsValid[this.typeNetworkSelected].showRender && !this.customMode.active)) {
        this.typeNetworkSelected = this.networksSelected.length ?
          this.listNetworkSort.find(n => this.networksSelected.includes(n) && this.postNetworkIsValid[n].showRender) || ''
          : ''
      }

      if (!this.typeNetworkSelected && this.networksSelected.length) {
        this.typeNetworkSelected = this.listNetworkSort.find(n => this.networksSelected.includes(n))
      }
    },

    unassignCurrentUser() {
      this.$emit('unassignCurrentUser')
    },

    assignUsers() {
      this.$emit('assignUsers')
    },

    removePage(pageId) {
      if (this.mode == 'update') return
      const removedPage = this.pagesSelected.find(page => page.id === pageId)
      const pagesSelected =  this.pagesSelected.filter(page => page.id !== pageId)
      this.$store.commit('selectPage/updatePagesSelected', {pagesId: pagesSelected.map(p => p.id)});

      if (removedPage && this.featuredPageIdByNetwork[removedPage.network] === pageId) {
        this.$delete(this.featuredPageIdByNetwork, removedPage.network)
      }

      //pour planner old
      localStorage.setItem('last_selected_pages',JSON.stringify(pagesSelected))
    },

    //////////// METHOD FOR FORMDATA ////////////


    ////////////////// SORT DATA //////////////////

    setPagesInstagramActivedShareStory() {
      console.log("setPagesInstagramActivedShareStory",JSON.parse(JSON.stringify(this.saveAllFormData)))
      let defaultActivedShareStory = this.customMode.active ? (this.saveAllFormData.main.formDataNetwork.instagram.storification ? this.saveAllFormData.main.formDataNetwork.instagram.storification.active : null)
        : (this.formData.formDataNetwork.instagram.storification ? this.formData.formDataNetwork.instagram.storification.active : null)

      //regarde si la valeur de storification dans la customisation de instagram
      let saveNetworkIsActiveStory = null

      if (
        this.customModeIsAvailable &&
        this.saveAllFormData.networks?.['instagram']?.formDataNetwork?.instagram?.storification?.hasOwnProperty('active')
      ) {
        saveNetworkIsActiveStory =  this.saveAllFormData.networks['instagram'].formDataNetwork.instagram.storification.active
      }

      this.pagesInstagramActivedShareStory = this.pagesSelected.filter(page => {

        let isActived
        if (page.network !== 'instagram') {
          isActived = false
        }else if (
          this.customModeIsAvailable &&
          this.saveAllFormData.pages?.[page.id]?.formDataNetwork?.instagram?.storification?.hasOwnProperty('active')
        ) {
          isActived = this.saveAllFormData.pages[page.id].formDataNetwork.instagram.storification.active
        }else if (saveNetworkIsActiveStory !== null) {
          isActived = saveNetworkIsActiveStory
        }else{
          isActived = defaultActivedShareStory
        }
        console.log("setPagesInstagramActivedShareStory",page.id,isActived)
        return isActived

      })
    },

    generateStoryShare() {
      console.log("generateStoryShare")
      this.setPagesInstagramActivedShareStory()
      const idStickerPost = 1111111111111

      const replaceMentions = (text, mentions) => {
        return text.trim().replace(/@(\d{13})/g, (match, id) => {
          const mention = mentions[id];
          if (mention) {
            return mention.mention && mention.mention.instagram ? `@${mention.mention.instagram.id || mention.mention.instagram.name}` : mention.textDefault;
          }
          return match;
        });
      }

      const getTemplate = (file, typePost, textContent = '', mentions) =>{
        console.log("generateStoryShare getTemplate",file, typePost, textContent, mentions)
        if (mentions) textContent = replaceMentions(textContent.slice(0, 213), mentions).slice(0, 200)
        return {
          "storification":{
            "0":{
              // "background":{"color":"#8A7A54"},
              ...JSON.parse(JSON.stringify(formDataDefault.storification[0])),
              "stickers":{
                [idStickerPost]:{
                  "type":"post",
                  "disableDelete": true,
                  "disableIncreaseZIndex": true,
                  "isEditing":false,
                  "position":{"x":50,"y":50},
                  "transform":{"rotate":0,"scale":1},
                  "data":{
                    url: file.url,
                    width: file.info.width,
                    height: file.info.height,
                    type: file.info.type2,
                    fileType: file.info.type,
                    typePost: typePost,
                    styleVariant: 1,
                    'textContent': textContent
                  },
                  "id": idStickerPost,
                  "zIndex":9
                }
              }
            }
          }
        }
      }
      //Permet de generer les storifications
      //si storification dans le form main et si file alors story
      let files = []
      let template = null

      if (this.pagesInstagramActivedShareStory.length) {
        let formDataRef = deepClone(this.saveAllFormData.main)
        mergeUpdates(formDataRef,this.saveAllFormData.networks['instagram'])


        files = getFilesByNetwork(formDataRef.files, ['instagram'], formDataRef.formDataNetwork, this.files)['instagram']

        if (files.length) {
          let refreshBackgroundColor = true
          const typePost = files.length > 1 ? 'carousel' : files[0].info.type2 == 'video' ? 'reel' : 'simple'

          template = getTemplate(
            files[0],
            typePost,
            unescapeSpecialChars(formDataRef.textContent),
            {
              ...(this.saveAllFormData.main.mentions || {}),
              ...(this.saveAllFormData.networks.instagram ? this.saveAllFormData.networks.instagram.mentions : {}),
            }
          )
          console.log("generateStoryShare template",template)
          //Objectif: garder la story intacte et juste modifier le sticker post
          if (!this.saveAllFormData.main.storification)  this.$set(this.saveAllFormData.main, 'storification', template.storification)
          else if(!this.saveAllFormData.main.storification[0]) this.$set(this.saveAllFormData.main.storification, 0 , template.storification[0])
          else if(!this.saveAllFormData.main.storification[0].stickers) {
            refreshBackgroundColor = false
            this.$set(this.saveAllFormData.main.storification[0], 'stickers' , template.storification[0].stickers)
          }else{
            const stickerPost = this.saveAllFormData.main.storification[0].stickers[idStickerPost]
            if (!stickerPost) {
              this.$set(this.saveAllFormData.main.storification[0].stickers, idStickerPost , template.storification[0].stickers[idStickerPost])
            }else{
              if (this.saveAllFormData.main.storification[0].stickers[stickerPost.id].data.idFile == files[0].id) refreshBackgroundColor = false
              this.$set(this.saveAllFormData.main.storification[0].stickers[stickerPost.id], 'data', {
                ...template.storification[0].stickers[idStickerPost].data,
                styleVariant: this.saveAllFormData.main.storification[0].stickers[stickerPost.id].data.styleVariant || 1

              })
            }
          }


          if (refreshBackgroundColor && files[0].info.averageColor) {
            this.$set(this.saveAllFormData.main.storification[0].background, 'color', files[0].info.averageColor)
          }
        }else{
          this.$delete(this.saveAllFormData.main.storification[0].stickers, idStickerPost)
        }


        //Retire les storification des pages qui ne sont plus active
        Object.keys(this.saveAllFormData.pages).forEach(pageId => {
          let pageIsActived = this.pagesInstagramActivedShareStory.some(page => page.id == pageId)
          if (!pageIsActived && this.saveAllFormData.pages[pageId] && this.saveAllFormData.pages[pageId].storification) {
            this.$delete(this.saveAllFormData.pages[pageId], 'storification')
          }
        })

        //custom page
        this.pagesInstagramActivedShareStory.forEach((page, index) => {

          if (this.saveAllFormData.pages[page.id]) {

            const newTextContent = this.saveAllFormData.pages[page.id] && this.saveAllFormData.pages[page.id].hasOwnProperty('textContent') ? this.saveAllFormData.pages[page.id].textContent : undefined

            let newFiles = []
            if (this.saveAllFormData.pages[page.id].files) {
              newFiles = this.saveAllFormData.pages[page.id].files.filter(({id:idFile}) => (
                ['video', 'image'].includes(this.files[idFile].info.type2) && this.files[idFile].info.type2 !== 'image/gif'
              ))
            }

            if (newFiles.length || files.length) {
              if (!newTextContent) {
                try {
                  this.$delete(this.saveAllFormData.pages[page.id].storification[0].stickers[idStickerPost].data, "textContent")
                } catch (error) { /* ignored */ }
              }

              if (!newFiles.length) {
                try {
                  this.$delete(this.saveAllFormData.pages[page.id].storification[0].stickers[idStickerPost].data, "idFile")
                  this.$delete(this.saveAllFormData.pages[page.id].storification[0].stickers[idStickerPost].data, "typePost")
                } catch (error) { /* ignored */ }
              }



              let refreshBackgroundColor = true
              let typePost = null

              if (newFiles.length) typePost = newFiles.length > 1 ? 'carousel' : this.files[newFiles[0].id].info.type2 == 'video' ? 'reel' : 'simple'
              else typePost = files.length > 1 ? 'carousel' : this.files[files[0].id].info.type2 == 'video' ? 'reel' : 'simple'

              template = getTemplate(
                newFiles.length ? this.files[newFiles[0].id] : this.files[files[0].id],
                typePost,
                newTextContent ? unescapeSpecialChars(newTextContent) : unescapeSpecialChars(formDataRef.textContent),
                {
                  ...(this.saveAllFormData.main.mentions || {}),
                  ...(this.saveAllFormData.networks.instagram ? this.saveAllFormData.networks.instagram.mentions : {}),
                  ...(this.saveAllFormData.pages[page.id].mentions || {}),
                }

              )

              //si le main embarque deja la storification alors on netoie la template
              if (this.saveAllFormData.main.storification[0].stickers[idStickerPost]) {
                template.storification[0] = {
                  stickers: {
                    [idStickerPost]:{
                      data:{}
                    }
                  }
                }

                if (newFiles.length) {
                  template.storification[0].stickers[idStickerPost].data.idFile = newFiles[0].id
                  template.storification[0].stickers[idStickerPost].data.typePost = typePost
                }

                if (newTextContent) {
                  template.storification[0].stickers[idStickerPost].data.textContent = replaceMentions(
                    unescapeSpecialChars(newTextContent),
                    {
                      ...(this.saveAllFormData.main.mentions || {}),
                      ...(this.saveAllFormData.networks.instagram ? this.saveAllFormData.networks.instagram.mentions : {}),
                      ...(this.saveAllFormData.pages[page.id].mentions || {}),
                    }
                  )
                }

              }


              if(!this.saveAllFormData.pages[page.id].storification) {
                this.$set(this.saveAllFormData.pages[page.id], 'storification', template.storification)
              }else if(!this.saveAllFormData.pages[page.id].storification[0]) {
                this.$set(this.saveAllFormData.pages[page.id].storification, 0 , template.storification[0])
              }else if(!this.saveAllFormData.pages[page.id].storification[0].stickers) {
                refreshBackgroundColor = false
                this.$set(this.saveAllFormData.pages[page.id].storification[0], 'stickers' , template.storification[0].stickers)
              }else{

                const stickerPost = this.saveAllFormData.pages[page.id].storification[0].stickers[idStickerPost]
                if (!stickerPost) {
                  this.$set(this.saveAllFormData.pages[page.id].storification[0].stickers, idStickerPost, template.storification[0].stickers[idStickerPost])
                }else{
                  if (
                    newFiles.length &&
                    this.saveAllFormData.pages[page.id].storification[0].stickers[idStickerPost] &&
                    this.saveAllFormData.pages[page.id].storification[0].stickers[idStickerPost].data &&
                    this.saveAllFormData.pages[page.id].storification[0].stickers[idStickerPost].data.idFile &&
                    this.saveAllFormData.pages[page.id].storification[0].stickers[idStickerPost].data.idFile == newFiles[0].id
                  )  {
                    refreshBackgroundColor = false
                  }

                  this.$set(this.saveAllFormData.pages[page.id].storification[0].stickers[idStickerPost], 'data', {
                    ...(this.saveAllFormData.pages[page.id].storification[0].stickers[idStickerPost].data || {}),
                    ...template.storification[0].stickers[idStickerPost].data
                  })
                }
              }

              if (refreshBackgroundColor && newFiles.length && this.files[newFiles[0].id].info.averageColor) {
                if (!this.saveAllFormData.pages[page.id].storification[0].background) {
                  this.$set(this.saveAllFormData.pages[page.id].storification[0], 'background', {color: this.files[newFiles[0].id].info.averageColor})
                }else{
                  this.$set(this.saveAllFormData.pages[page.id].storification[0].background, 'color', this.files[newFiles[0].id].info.averageColor)
                }
              }

            }else{
              this.$delete(this.saveAllFormData.pages[page.id], 'storification')
            }

          }

        });
      }
    },

    removeAllStickersPost() {
      const idStickerPost = 1111111111111
      if (this.saveAllFormData.main && this.saveAllFormData.main.storification && Object.keys(this.saveAllFormData.main.storification).length) {
        Object.keys(this.saveAllFormData.main.storification).forEach(storyId => {
          if (this.saveAllFormData.main.storification[storyId].stickers && Object.keys(this.saveAllFormData.main.storification[storyId].stickers).length) {
            const stickerPost = this.saveAllFormData.main.storification[storyId].stickers[idStickerPost]
            if (stickerPost) {
              this.$delete(this.saveAllFormData.main.storification[storyId].stickers, stickerPost.id)
            }
          }
        })
      }
      if (this.saveAllFormData.pages && Object.keys(this.saveAllFormData.pages).length) {
        Object.keys(this.saveAllFormData.pages).forEach(pageId => {
          if (this.saveAllFormData.pages[pageId].storification && Object.keys(this.saveAllFormData.pages[pageId].storification).length) {
            Object.keys(this.saveAllFormData.pages[pageId].storification).forEach(storyId => {
              if (this.saveAllFormData.pages[pageId].storification[storyId].stickers && Object.keys(this.saveAllFormData.pages[pageId].storification[storyId].stickers).length) {
                const stickerPost = this.saveAllFormData.pages[pageId].storification[storyId].stickers[idStickerPost]
                if (stickerPost) {
                  this.$delete(this.saveAllFormData.pages[pageId].storification[storyId].stickers, stickerPost.id)
                }
              }
            })
          }
        })
      }
    },

    /////////////// SAVE - POSTING ///////////////

    saveDraft() {

      if (this.isFileUploading) {
        EventBus.$emit("showModal", 
            "Media en cours de chargement", 
            "Voulez-vous attendre la fin du chargement avant de sauvegarder ? ", 
            "Attendre", 
            "Sauvegarder quand même",  
            ()=>{
                return
            },
            ()=>{
              this.$emit('saveFormData', this.customMode.active ? this.customMode.selection.page || this.customMode.selection.network : null)
              this.$emit('saveDraft')
            },
        );
      }else{
        this.$emit('saveFormData', this.customMode.active ? this.customMode.selection.page || this.customMode.selection.network : null)
        this.$emit('saveDraft')
      }
    },

    sendPostAllPost() {
      if (this.isFileUploading || this.hasFailedUpload) return
      this.$emit('sendPostAllPost')
    },

    // Called by PostCreator.vue's sendPostAllPost at submit time - every session still actively
    // exporting right now (across general/network/page scopes, see mediaEditorSessions) is a media
    // this post's publish must not run ahead of. Returns each job's scopeKey/fileIdOrigin to apply
    // its result once resolved (see PostCreator.vue's applyBackgroundMediaResult - mediaExportJobs.js's
    // own job record only knows scopeKey/kind/status/progress/resultFile/error, not which media it's
    // replacing), and timelineState/extraFiles (see onExportStart - the "resume" data a later re-edit
    // needs, exactly like endEditMedia's own newFileEntry attaches for the "stay on page" case -
    // without it, re-opening the published result would show only the flattened export with no way
    // back to the original clips/overlays/cuts).
    getPendingMediaExportSessionsInfo() {
      return Object.values(this.mediaEditorSessions)
        .filter(session => session.exporting && session.jobId)
        .map(session => ({
          jobId: session.jobId,
          scopeKey: session.scopeKey,
          fileIdOrigin: session.fileIdOrigin,
          timelineState: session.timelineState,
          extraFiles: session.extraFiles
        }))
    },

    // Marks job ids as owned by a pending publish (see mediaExportJobs.js's registerPendingPublish) -
    // endEditMedia/onExportFailed become no-ops for these (see the claimedMediaJobIds check in both),
    // so the deferred-publish path is the only thing left to apply their eventual result.
    claimMediaExportJobIds(jobIds) {
      jobIds.forEach(jobId => this.$set(this.claimedMediaJobIds, jobId, true))
    }
  },

  computed: {
    savePostTemplateData() {
      return {
        data: {
          saveAllFormData: this.saveAllFormData,
          files: this.files,
          tab: this.tab
        },
        source: 'post-creation'
      }
    },

    currentUser() {
      return this.$store.getters['users/getCurrentUser']
    },
    isPrenium() {
      return true
      // return this.currentUser?._premium?.plan > 1;
    },

    allPages() {
      return this.$store.getters['selectPage/selectPageAllPages'];
    },

    pagesSelected() {
      return this.$store.getters['selectPage/selectPagePageSelected'].map(id => this.allPages[id]);
    },

    isDemo() {
      return this.$store.getters['demo/isActive'];
    },

    pagesSelectedIncludeConciergerie() {
      return allInstagramNative(this.pagesSelected)
    },

    isFacebookConciergerieEdit() {
      return this.pagesSelected.some(p => p.network === 'facebook' && p.story_config && p.story_config.created);
    },

    hasMixedStoryNetworks() {
      return this.pagesSelected.some(p => p.network === 'instagram') && this.pagesSelected.some(p => p.network === 'facebook')
    },

    networksSelected() {
      return [...new Set(this.$store.getters['selectPage/selectPagePageSelected'].map(id => this.allPages[id].network))];
    },

    // Moved up from Form.vue - kept as a single computed rather than inlining `true` at both call
    // sites, so there's still one obvious place to re-gate it by environment again (matching the
    // codebase's existing NODE_ENV convention - see router/index.js's
    // InProduction/isPresenceManagementEnabled, Tabs.vue, User.vue) if a real issue ever requires
    // pulling it back.
    isMediaEditorEnabled() {
      return true
    },

    // Same notion of "context" saveFormData/generateFormData already key their pages/networks
    // overrides by (StandardTab.vue's handleChangecustomMode/saveAllFormData.pages|networks) -
    // reused here so a video session started while viewing a given page/network personalization
    // stays tied to that exact context, distinct from "general" or any other page/network.
    currentMediaEditorScopeKey() {
      if (this.customMode.active && this.customMode.selection.page) return 'page:' + this.customMode.selection.page.id
      if (this.customMode.active && this.customMode.selection.network) return 'network:' + this.customMode.selection.network
      return 'general'
    },

    // From most to least specific: a page inherits from its network, which inherits from general -
    // the exact same override chain saveAllFormData.pages/networks/main already use. A scope with
    // no video session of its own should still show/resume the nearest ancestor's one in progress,
    // exactly like it would inherit that ancestor's text/settings if it had no override yet.
    currentMediaEditorScopeChain() {
      const chain = []
      if (this.customMode.active && this.customMode.selection.page) {
        chain.push('page:' + this.customMode.selection.page.id)
        if (this.customMode.selection.page.network) chain.push('network:' + this.customMode.selection.page.network)
      } else if (this.customMode.active && this.customMode.selection.network) {
        chain.push('network:' + this.customMode.selection.network)
      }
      chain.push('general')
      return chain
    },

    // What actually gets passed to <Form> as :mediaEditorData - same shape/contract as before
    // this feature existed, so Form.vue itself needs zero changes: it always just sees "the"
    // session, which now happens to be whichever one belongs to the scope currently on screen (or,
    // failing that, the nearest ancestor's - see currentMediaEditorScopeChain).
    currentMediaEditorData() {
      return this.resolveInheritedMediaEditorSession() || { fileIdOrigin: null, fileId: null, exporting: false, exportProgress: 0 }
    },

    // Every session with a live editor/export - the currently active one per scope, but also any
    // superseded ones still exporting quietly in the background after a same-scope re-edit. Each
    // gets its own <MediaEditor> portal instance in the template below.
    activeMediaEditorSessions() {
      return Object.values(this.mediaEditorSessions).filter(session => session.fileIdOrigin)
    },

    phoneIsFirstPlan() {
      let validmodes = ['addCollaboratorMode','addIdentifierMode','addPlaceMode', 'addMusicMode', 'addTiktokMusicMode','addMentionMode','addHashtagMode','addVariableMode','addProductMode', 'inputMode']
      return validmodes.find(v => this.modes.includes(v)) ? true : false
    },

    textContentConverted() {

      const regex = /^(<br\s*\/?>|\\n|\s*)+$/i
      if (!this.formData.textContent || regex.test( this.formData.textContent)) return ''

      return this.formData.textContent.replaceAll("\\n", '<br>')
    },

    getNamePageNetwork() {
      if (this.previewMode.active && this.previewMode.pageSelected) return this.previewMode.pageSelected.name
      if ((this.customMode.active) && this.customMode.selection.page ) return this.customMode.selection.page.name

      const page = this.pagesSelected.find(p => p.network == this.typeNetworkSelected)
      return page ? page.name : ''
    },

    filesSortByNetwork() {
      return getFilesByNetwork(this.formData.files, this.listNetworkSort, this.formData.formDataNetwork, this.files)
    },

    countDataFormRequestValid() {
      return Object.values(this.dataFormRequest).filter(form => !form.hasOwnProperty('error')).length
    },

    isCurrentUserAssigned() {
      return (
        this.formData.planifiedDate.date &&
        this.idUsersAssigned.length &&
        this.requiredValidation &&
        this.idUsersAssigned.includes(this.currentUser.id)
      )
    },

    textSwitchPreview() {
      if (this.mode == 'update') return this.$t('dash.post-creator.action.update')
      if (this.formData.planifiedDate.date && this.idUsersAssigned.length && this.requiredValidation) {
        if (this.isCurrentUserAssigned){
          return this.$t('dash.post-creator.action.validate')
        }else{
          return this.$t('dash.post-creator.action.send-for-validation')
        }
      }


      let postPlanified = false
      let postInstantly = false

      const formMain = !this.customMode.active ? this.formData : this.saveAllFormData.main

      for (let i = 0; i < this.pagesSelected.length; i++) {
        if (postPlanified && postInstantly) break;
        const page = this.pagesSelected[i];

        const formDataByPage = this.customMode.active && this.customMode.selection.page && this.customMode.selection.page.id == page.id ? this.formData : this.saveAllFormData.pages[page.id]
        const formDataByNetwork = this.customMode.active && this.customMode.selection.network == page.network ? this.formData : this.saveAllFormData.networks[page.network]


        if (formDataByPage && formDataByPage.planifiedDate) {
          if (formDataByPage.planifiedDate.date || formDataByPage.planifiedDate.hours) {
            postPlanified = true
          }else {
            postInstantly = true
          }
        }else if(formDataByNetwork && formDataByNetwork.planifiedDate){
          if (formDataByNetwork.planifiedDate.date || formDataByNetwork.planifiedDate.hours) {
            postPlanified = true
          }else {
            postInstantly = true
          }
        }else{

          if (formMain.planifiedDate.date || formMain.planifiedDate.hours) {
            postPlanified = true
          } else {
            postInstantly = true
          }
        }
      }

      if (postPlanified && postInstantly) {
        return this.$t('dash.post-creator.action.publish-and-schedule');
      } else if (postPlanified) {
        if (this.idUsersAssigned.length && this.requiredValidation && this.idUsersAssigned.includes(this.currentUser.id)) return this.$t('dash.button.schedule')
        if (this.mode == 'edit' && !this.isMongoDraftEdit) return this.$t('dash.post-creator.action.apply')
        return this.$t('dash.button.schedule');
      } else if (postInstantly) {
        return this.$t('dash.post-creator.action.publish');
      }

      return '';
    },

    textBtnFinish() {
      if (this.mode == 'update')  {
        const pagesCount = this.pagesSelected.filter(page =>
          this.editableNetworks.includes(page.network) &&
          this.dataFormRequest[page.id] && !this.dataFormRequest[page.id].hasOwnProperty('error')
        ).length

        return `${this.$t(pagesCount > 1 ? 'dash.post-creator.action.update-on-pages' : 'dash.post-creator.action.update-on-page', { count: pagesCount })}`
      }

      if (this.formData.planifiedDate.date && this.idUsersAssigned.length && this.requiredValidation) {
        if (this.idUsersAssigned.includes(this.currentUser.id)) {
          return this.$t('dash.post-creator.action.validate')
        }else{
          return this.$t('dash.post-creator.action.send-for-validation')
        }

      }
      const forms = Object.values(this.dataFormRequest);

      const postPlanified = forms.filter(form => !form.hasOwnProperty('error') && form.scheduled);
      const postInstantly = forms.filter(form => !form.hasOwnProperty('error') && !form.scheduled);

      if (postPlanified.length && postInstantly.length) {
        return this.$t('dash.post-creator.action.publish-and-schedule');
      } else if (postPlanified.length) {
        return `${this.$t(postPlanified.length > 1 ? 'dash.post-creator.action.schedule-on-pages' : 'dash.post-creator.action.schedule-on-page', { count: postPlanified.length })}`;
      } else if (postInstantly.length) {
        return `${this.$t(postInstantly.length > 1 ? 'dash.post-creator.action.publish-on-pages' : 'dash.post-creator.action.publish-on-page', { count: postInstantly.length })}`;
      }

      return '';
    },

    uploadBlockedTooltipText() {
      return this.hasFailedUpload
        ? this.$t('dash.post-creator.media.upload-failed')
        : this.$t('dash.post-creator.media.uploading')
    },

    textPostFailed () {

      if (!Object.values(this.postNetworkIsValid).some(obj => obj.showRender == true)) {
        return this.$t('dash.post-creator.error.add-content')
      }

      if (this.previewMode.active) {
        if (this.customMode.selection.page && this.customMode.selection.page.id && this.dataFormRequest[this.customMode.selection.page.id] && this.dataFormRequest[this.customMode.selection.page.id].error) {
          return this.dataFormRequest[this.customMode.selection.page.id].error
        }
      }else{
        if (!this.customMode.active  && this.typeNetworkSelected && this.postNetworkIsValid[this.typeNetworkSelected] && !this.postNetworkIsValid[this.typeNetworkSelected].showRender) {
          return this.postNetworkIsValid[this.typeNetworkSelected].error.length ? this.postNetworkIsValid[this.typeNetworkSelected].error[0].textError : ''
        }

        if (this.customMode.active) {
          if (this.customMode.selection.network) {
            if (!this.postNetworkIsValid[this.customMode.selection.network].showRender) return this.postNetworkIsValid[this.customMode.selection.network].error.length ? this.postNetworkIsValid[this.customMode.selection.network].error[0].textError : ''
          }else if(this.customMode.selection.page && this.customMode.selection.page.network){
            if (!this.postNetworkIsValid[this.customMode.selection.page.network].showRender) return this.postNetworkIsValid[this.customMode.selection.page.network].error.length ? this.postNetworkIsValid[this.customMode.selection.page.network].error[0].textError : ''
          }
        }
      }

      return ''
    },

    title () {

      switch (this.mode) {
        case "edit":
          return this.$t('dash.post-creator.title.edit-mode')
        case "draft":
          return this.$t('dash.post-creator.title.draft')
        case "update":
          return this.$t('dash.post-creator.title.update-post')
        default:
          return this.previewMode.active ? this.$t('dash.post-creator.title.preview') : this.$t('dash.post-creator.title.new')

      }


    },

    storificationActived() {
      return this.formData.formDataNetwork.instagram.storification.active ||
        (this.saveAllFormData.networks.instagram &&
          this.saveAllFormData.networks.instagram.formDataNetwork &&
          this.saveAllFormData.networks.instagram.formDataNetwork.instagram.storification &&
          this.saveAllFormData.networks.instagram.formDataNetwork.instagram.storification.active)
    },

    pageForRenderPost() {
      //retourne un array de page a prendre en compte pour le rendu du post
      // Garde contre un null : handleChangecustomMode met customMode.active à true de façon
      // synchrone, mais ne renseigne customMode.selection.page/.network que ~200ms plus tard (dans
      // son setTimeout, pour laisser l'animation de transition démarrer avec l'ancien contexte).
      // Sans cette garde, ce computed renvoyait [null] pendant cette fenêtre, faisant planter
      // RenderPostManager.vue's pagesEdited() sur `page.id` (TypeError: Cannot read properties of
      // null (reading 'id')) - un crash de rendu qui interrompt le patch Vue en plein switch de
      // mode, ce qui peut laisser la preview (et donc la barre de progression de l'export vidéo
      // qu'elle affiche) bloquée sur son dernier état affiché avec succès.
      if (this.previewMode.active) return this.previewMode.pageSelected ? [this.previewMode.pageSelected] : []
      else if (this.customMode.active && !this.customMode.selection.network) return this.customMode.selection.page ? [this.customMode.selection.page] : []
      else return this.pagesSelected.filter(p => p.network == this.typeNetworkSelected)
    },

    idsPagesEditedForRenderPost() {
      //retourne un array de page qui on une personalisation active a prendre en compte pour le rendu du post
      if (this.previewMode.active) return []
      if (!this.customModeIsAvailable) return []

      return this.pagesSelected.filter((p) => {
        return (
          this.saveAllFormData.pages[p.id] &&
          Object.keys(this.saveAllFormData.pages[p.id]).length > 0
          //&& (!this.customMode.active || !this.customMode.selection.page)   //je l'ai commenter pour avoir en temps telle les id pages
        )
      }).map(p => p.id)
    },

    postNetworkIsValid() {
      const validator = postNetworkValidator(this.listNetworkSort,  this.filesSortByNetwork,  this.formData.formDataNetwork , this.textContentConverted)
      return validator
    },

    // Pages Facebook dont le post (ou un commentaire) depasse le seuil sur de mentions, en tenant
    // compte des personnalisations : la page en infraction peut tres bien etre une page qui n'est
    // pas affichee a l'ecran. Purement informatif, ca ne bloque ni le rendu ni la publication.
    mentionsOverSafeLimitByPage() {
      return getMentionsOverSafeLimit({
        network: 'facebook',
        maxMentions: maxMentionsSafeByNetwork.facebook,
        pagesSelected: this.pagesSelected,
        saveAllFormData: this.saveAllFormData,
        formData: this.formData,
        customMode: this.customMode,
        customModeIsAvailable: this.customModeIsAvailable,
      })
    },

    customModeIsAvailable() {
      return customModeIsAvailableUtil({
        pagesSelected: this.pagesSelected,
        validator: this.customMode.active ? null : this.postNetworkIsValid,
        formDataMain: this.saveAllFormData.main,
        files: this.files,
      })
    },

    countPagePerNetwork() {
      return this.pagesSelected.reduce((count, page) => {
        count[page.network] = (count[page.network] || 0) + 1;
        return count;
      }, {})
    },

    formDataPatch() {
      if (this.previewMode.active) return {}

      // mode personnalisation PAR RÉSEAU : plusieurs pages de ce réseau peuvent encore être
      // empilées dans l'aperçu (cf. pageForRenderPost). formData contient déjà main+network
      // (generateFormData côté parent), mais pas la personnalisation propre à la page mise
      // en avant dans la pile - à appliquer ici comme en vue générale (cf. plus bas).
      if (this.customMode.active && this.customMode.selection.network) {
        const patch = {}
        const network = this.customMode.selection.network
        const networkPages = this.pagesSelected.filter(p => p.network == network)
        const featuredPage = getFeaturedPage(networkPages, this.featuredPageIdByNetwork[network])

        if (featuredPage && this.saveAllFormData.pages[featuredPage.id]) {
          mergeUpdates(patch, this.saveAllFormData.pages[featuredPage.id])
        }

        return patch
      }

      // mode personnalisation D'UNE PAGE précise : formData contient déjà main+network+page
      // (generateFormData), rien à patcher en plus.
      if (this.customMode.active) return {}

      if (!this.customModeIsAvailable) return {}

      // vue générale (hors mode personnalisation) : la personnalisation de contenu appliquée
      // est celle de la page mise en avant (choisie par l'utilisateur, sinon la règle par
      // défaut de la pile d'avatars) - fonctionne aussi bien avec une seule page qu'avec
      // plusieurs du même réseau
      let patch = {}
      if (this.saveAllFormData.networks[this.typeNetworkSelected]) {
        patch = JSON.parse(JSON.stringify(this.saveAllFormData.networks[this.typeNetworkSelected]))
      }

      const networkPages = this.pagesSelected.filter(p => p.network == this.typeNetworkSelected)
      const featuredPage = getFeaturedPage(networkPages, this.featuredPageIdByNetwork[this.typeNetworkSelected])

      if (featuredPage && this.saveAllFormData.pages[featuredPage.id]) {
        mergeUpdates(patch, this.saveAllFormData.pages[featuredPage.id])
      }

      return patch
    }
  },



  watch: {
    networksSelected(newValue, oldValue) {
      this.updateTypeNetworkSelected()
    },

    postNetworkIsValid(validator) {
      console.log('postNetworkIsValid changed')
      this.updateTypeNetworkSelected()
    },

    ["formData.textContent"](newValue, oldValue) {
      // if (this.customMode.active) this.$emit('saveFormData', this.customMode.selection.page || this.customMode.selection.network)
    },

    ["formData.formDataNetwork.instagram.storification.active"]: {
      handler() {
        this.setPagesInstagramActivedShareStory()
      },
      immediate: true
    },

    ["previewMode.active"]: {
      handler(value, oldValue) {
        if (value) {
          if (this.previewMode.pageSelected) this.toggleSelectPageForcustomMode(this.previewMode.pageSelected)

          if (oldValue == undefined) {
            this.formShow = `${this.customMode.active ? "preview-left" : "preview-right"} annimate-switch-preview-mode`
          }else{
            this.formShow = this.customMode.active ? "preview-left" : "preview-right"
            if (this.timeOutAnnimateForm) clearTimeout(this.timeOutAnnimateForm)
            this.$nextTick(() => {
              this.timeOutAnnimateForm = setTimeout(() => {
                if (this.$refs.postCreator && this.$refs.postCreator.classList) {
                  this.$refs.postCreator.classList.add('annimate-switch-preview-mode');
                }
              }, 500);
            })
          }

        }else{
          if (this.$refs.postCreator && this.$refs.postCreator.classList) {
            this.$refs.postCreator.classList.remove('annimate-switch-preview-mode');
          }
          if (this.timeOutAnnimateForm) clearTimeout(this.timeOutAnnimateForm)
          this.$nextTick(() => {
            this.timeOutAnnimateForm = setTimeout(() => {
              if (this.formShow.startsWith("preview-left")) {
                this.formShow = "formUnique"
              }else{
                this.formShow = "formMultiple"
              }
            }, 1000);
          })
        }
      },
      immediate: true
    },

    customModeIsAvailable: {
      handler(value) {
        this.setPagesInstagramActivedShareStory()
      },
      immediate: true
    }
  },



  beforeDestroy () {
    EventBus.$off('postCreatorAddMode', this.addMode);
    EventBus.$off('postCreatorRemoveMode', this.removeMode);
    //this.$emit('saveFormData', this.customMode.active ? this.customMode.selection.page || this.customMode.selection.network : null)
  }

}
</script>
